import t from './translator'
// const Translator = {
//   t: (mess) => {return mess;}
// }

export default t;



// WEBPACK FOOTER //
// ./src/translations/index.js